export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Bold.6978cc29a09f7c2d7c2d408e3f822f4f.woff2";